class ImageViewer extends HTMLElement {
  connectedCallback() {
    this._dialog = this.querySelector('[data-image-viewer-dialog]');
    this._stack = this.querySelector('[data-image-viewer-stack]');
    if (!this._dialog || !this._stack) return;

    this._slides = [...this.querySelectorAll('[data-image-viewer-slide]')];
    this._thumbnails = [...this.querySelectorAll('[data-image-viewer-thumbnail]')];
    this._triggerElement = null;

    this._handleOpenViewer = (event) => {
      const { mediaId } = event.detail;
      const wasOpen = this._dialog.open;

      this._triggerElement = event.target;

      if (!wasOpen) {
        this._dialog.showModal();
      }

      const targetSlide = this._slides.find((slide) => slide.dataset.mediaId === mediaId);
      targetSlide?.scrollIntoView({ block: 'start' });
    };

    document.addEventListener('gallery:open-viewer', this._handleOpenViewer);

    for (const closeButton of this.querySelectorAll('[data-image-viewer-close]')) {
      closeButton.addEventListener('click', () => this._dialog.close());
    }

    this._handleDialogClose = () => {
      if (typeof this._triggerElement?.focus === 'function') {
        this._triggerElement.focus();
      }
    };
    this._dialog.addEventListener('close', this._handleDialogClose);

    for (const thumbnail of this._thumbnails) {
      thumbnail.addEventListener('click', () => {
        const targetSlide = this._slides.find((slide) => slide.dataset.mediaId === thumbnail.dataset.mediaId);
        targetSlide?.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
    }

    this._intersectionRatios = new Map();

    this._observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          this._intersectionRatios.set(entry.target, entry.intersectionRatio);
        }

        let mostVisibleSlide = null;
        let highestRatio = 0;
        for (const [slide, ratio] of this._intersectionRatios) {
          if (ratio > highestRatio) {
            highestRatio = ratio;
            mostVisibleSlide = slide;
          }
        }

        if (!mostVisibleSlide) return;

        const activeMediaId = mostVisibleSlide.dataset.mediaId;
        for (const thumbnail of this._thumbnails) {
          thumbnail.dataset.active = String(thumbnail.dataset.mediaId === activeMediaId);
        }
      },
      { root: this._stack, threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] }
    );

    for (const slide of this._slides) {
      this._observer.observe(slide);
    }
  }

  disconnectedCallback() {
    this._observer?.disconnect();
    document.removeEventListener('gallery:open-viewer', this._handleOpenViewer);
  }
}

if (!customElements.get('image-viewer')) {
  customElements.define('image-viewer', ImageViewer);
}
